export function params(u, p) {
    var m = new RegExp('(?:&|/?)' + p + '=([^&$]+)').exec(u)
    var result = m ? m[1] : ''
    result = result.replace(/\?.*/, '')
    return result
}